import { IGruppo } from './../interfaces/IGruppo';
import * as Enum from '../utils/enums'
import * as Constants from '../utils/constants';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogService } from 'primeng/api';
import { Loading } from '../utils/loading';
import { TranslateService } from '@ngx-translate/core';
import { GruppoModalComponent } from '../gruppo-modal/gruppo-modal.component';
import { AlertUtil } from '../utils/alert-util';
import { RequestBuilder } from '../classes/request-builder';
import { GruppoService } from '../services/gruppo.service';
import { finalize } from 'rxjs/operators';
import { DataTableComponent } from '../data-table/data-table.component';
import { CommessaListModalComponent } from '../commessa-list-modal/commessa-list-modal/commessa-list-modal.component';

@Component({
  selector: 'app-gruppo',
  templateUrl: './gruppo.component.html',
  styleUrls: ['./gruppo.component.css']
})
export class GruppoComponent implements OnInit {

  //Variabili
  isAdmin: boolean = false
  disableGruppoTooltip: boolean = false

  gruppi: IGruppo[]
  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  @ViewChild("dtGruppi") dtGruppi: DataTableComponent

  constructor(private dialogService: DialogService,
    private translate: TranslateService,
    private alertUtil: AlertUtil,
    private gruppoService: GruppoService) { }

  ngOnInit() {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    this.checkUserRole(userRole)
    setTimeout(() => {
      this.getAllGruppi()
    }, 0);
  }

  /**
  * check role of user logged
  */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.disableGruppoTooltip = true
      this.isAdmin = true;
    } else {
      this.disableGruppoTooltip = false
      this.isAdmin = false;
    }
  }

  openGruppoModal(gruppo?: any) {
    //get header translation
    this.translate.get(["LBL_NEW_GRUPPO", "LBL_UPDATE_GRUPPO"]).subscribe(res => {
      //open gruppo modal
      let gruppoModal = this.dialogService.open(GruppoModalComponent, {
        data: {
          gruppo: gruppo
        },
        header: gruppo ? res["LBL_UPDATE_GRUPPO"] : res["LBL_NEW_GRUPPO"],
        width: '50%'
      })

      // refresh commesse when modal is closed and newGruppo is created
      gruppoModal.onClose.subscribe((newGruppo) => {
        if (newGruppo) {
          this.getAllGruppi()
        }
      })
    })
  }

  openCommesseModal(gruppo?: any) {
    //get header translation
    this.translate.get(["LBL_INTERVENTI_LIST"]).subscribe(res => {
      //open gruppo modal
      let gruppoModal = this.dialogService.open(CommessaListModalComponent, {
        data: {
          gruppo: gruppo
        },
        header: res["LBL_INTERVENTI_LIST"],
        width: '50%'
      })

      // refresh commesse when modal is closed and newGruppo is created
      gruppoModal.onClose.subscribe((newGruppo) => {
        if (newGruppo) {
          this.getAllGruppi()
        }
      })
    })
  }

  /**
   * delete object confirmation
   */
  openDeleteDialog(gruppoObj: IGruppo) {
    this.alertUtil.showConfirmationAlert("LBL_CONFIRM_GRUPPO_DELETE", null, null, null, null, () => {
      this.deleteGruppo(gruppoObj)
    });
  }

  /**
   * fetch all gruppi for table
   */
  getAllGruppi() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.gruppoService.getAllGruppi(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.dtGruppi.resetTable()
          this.gruppi = response.data
          this.getCommesseAssociateFromResponse()
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
  * get commesse associate al gruppo
  */
  getCommesseAssociateFromResponse() {
    let commesseString = " "
    for (let i = 0; i < this.gruppi.length; i++) {//ciclo i gruppi
      let gruppo = this.gruppi[i]
      if (gruppo.Commesse) {
        if (gruppo.Commesse.length == 0) { //Controllo se Commesse è valorizzato
          commesseString = "Nessuna commessa associata"
          gruppo.CommesseAssociate = commesseString  // associo la stringa al campo CommesseAssociate
          commesseString = ""
        } else {
          commesseString = "Visualizza Commesse"
          // for (let y = 0; y < gruppo.Commesse.length; y++) { // ciclo commesse
          //   let commessa = gruppo.Commesse[y]
          //   commesseString += commessa.Codice + "," //costruisco la stringa delle commesse associate
          // }
          // commesseString = commesseString.slice(0, -1); // rimuovo l'ultima virgola
          gruppo.CommesseAssociate = commesseString  // associo la stringa al campo CommesseAssociate
          gruppo.isLink = true
          commesseString = ""
        }
      }
    }
  }

  /**
   * delete gruppo
   */
  deleteGruppo(gruppoObj: IGruppo) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(gruppoObj)
    this.gruppoService.deleteGruppo(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          //MESSAGGIO OK 
          this.alertUtil.showAlert("LBL_DELETE_GRUPPO_SUCCESS", null, null, null, () => {
            this.getAllGruppi()
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
}
